<template>
    <div id="quick_core_waybill_related_columns">
        <div class="ui divider"
            style="margin-top: 3px;">
        </div>
        <div class="ui form"
            :class="{'inverted': is_inverted}">

            <h3 style="margin: 0;">
                <!-- 快速套用必填欄位區 -->
                {{ $t('ui.scanner.helps.quick_required_field_div') }}
            </h3>
            <div class="field half"
                @click="is_edit_fields = true"
                v-for="related_column in current_scan_action_prototype_related_columns">
                <label
                    v-if="is_edit_fields"
                    style="font-size: 14px;">
                    {{ $t("models.attributes.core_waybills." + related_column.name) }}
                    <span v-if="related_column.is_required" style="font-size: 16px;color: red;">
                        *
                    </span>
                </label>
                <input type="text"
                    tabindex="-1"
                    autocomplete="off"
                    @focus="current_store.is_keydown = false"
                    @blur="current_store.is_keydown = true"
                    v-if="is_edit_fields"
                    v-model="quick_core_waybill_related_columns[related_column.name]"
                    :placeholder="(related_column.is_required) ? $t('ui.scanner.alerts.required_field') : $t('ui.scanner.alerts.if_have_write')"
                    :class="{
                        'is_required': related_column.is_required
                    }"
                    >

                <label
                    v-if="!is_edit_fields"
                    style="font-size: 14px;">
                    {{ $t("models.attributes.core_waybills." + related_column.name) }}
                    <span
                        style="color: red;"
                        v-if="related_column.is_required">
                        *
                    </span>
                    ： {{ quick_core_waybill_related_columns[related_column.name] || '無填寫' }}
                </label>
            </div>
        </div> <!-- End ui form -->

        <div class="toggle_is_edit_fields pointer"
            @click="is_edit_fields = !is_edit_fields">
            <i class="circular orange icon"
                :class="{
                    'inverted angle double up': is_edit_fields,
                    'large angle double down': !is_edit_fields,
                }">
            </i>
        </div>

        <div class="clear">
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    props: {
        is_inverted: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_edit_fields: true,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.scanner_module
        },
        settings() {
            return this.current_store.settings
        },
        current_scan_action_prototype_related_columns() {
            return this.$store.getters['provider/scanner_module/current_scan_action_prototype_related_columns']
        },
        quick_core_waybill_related_columns() {
            return this.current_store.quick_core_waybill_related_columns
        },
    },
    watch: {
    },
    mounted() {
    },
    methods: {
    },

}
</script>

<style lang="scss" scoped>
    #quick_core_waybill_related_columns {
        & {
            position: relative;
        }
        .ui.basic.label.inverted {
            background-color: var(--inverted-color) !important;
        }
        .inverted .field label {
            color: white;
        }
        .toggle_is_edit_fields {
            position: absolute;
            z-index: 1;
            right: -7px;
            bottom: -9px;
        }
        .field input {
            &::placeholder {
                color: #e77e39;
            }
            &.is_required::placeholder {
                color: red;
            }
        }
        .field {
            margin: 0 0 0.3em;
        }
    }

    @media only screen and (max-width: 767px) {
        #quick_core_waybill_related_columns {
            & {
                padding-left: 1rem;
                padding-right: 1rem;
            }
            .toggle_is_edit_fields {
                right: 0px;
            }
        }
    }

    @media only screen and (min-width: 767px) {
        #quick_core_waybill_related_columns {
            .field  {
                &.half {
                    width: calc(50% - 2%);
                    margin: .5% 1%;
                    display: inline-block;
                }
                &.full {
                    width: 100%;
                }
            }
        }
    }
</style>
